<template lang="pug">
  div
    .row
      .col-lg-6
        .d-flex.flex-row.align-items-center
          font-awesome-icon.account-page__icon(:icon=['far', 'heart'])
          h3.account-page__title {{ trans('menus.frontend.navigation.wishlist') }}
    .product-list.product-list--horizontal.row(v-if="products.length > 0")
      product-list-item(:product="product" v-for="product in products" :key="product.id" type="horizontal")
    p(v-if="products.length === 0") {{ trans('labels.frontend.account.wishlist.no_item') }}
</template>

<script>
import BreadcrumbsManager from '../../../mixins/BreadcrumbsManager';
import ProductListItem from '../../../components/product/ProductListItem.vue';
import { RepositoryFactory } from '../../../repositoryFactory';

const ProductRepository = RepositoryFactory.get('product');

export default {
  components: {
    ProductListItem,
  },
  mixins: [BreadcrumbsManager],
  metaInfo() {
    return {
      title: Lang.get('menus.frontend.navigation.wishlist'),
    };
  },
  data() {
    return {
      products: [],
    };
  },
  created() {
    this.setBreadcrumbs([
      { name: Lang.get('menus.frontend.navigation.wishlist') },
    ]);
  },
  mounted() {
    this.getProducts();
    this.$store.subscribe(() => {
      this.getProducts();
    });
  },
  methods: {
    async getProducts() {
      const wishlistIds = this.$store.getters['wishlist/items'] ?? [];
      if (wishlistIds.length > 0) {
        const { data } = await ProductRepository.get({ paginated: false, where_in: wishlistIds }).then((resp) => resp.data);
        this.products = data;
      } else if (wishlistIds.length === 0) {
        this.products = [];
      }
    },
  },
};
</script>
